import { call, put, select, take } from 'redux-saga/effects';

import { selectConfigurationParameterById } from '!core/redux';
import { getAllInstruments } from '!core/redux/userInstruments/userInstruments.selectors';
import { securityAccountSelectedSelector } from '!core/redux/userSecuritiesAccounts/userSecuritiesAccounts.selectors';
import { fundsServices } from '!views/Market';
import { handleSagaError } from '»utils/handleSagasError';

import { walletSlice } from './_wallet.slice';
import { walletServices } from './wallet.services';

const walletWorker = function* () {
  try {
    const securityAccount = yield select(securityAccountSelectedSelector);
    const hasFunds = yield select((state) =>
      selectConfigurationParameterById(state, 'HAS_FUNDS'),
    );

    let portfolio = yield call(walletServices.accountPortfolio, {
      account: securityAccount,
    });

    if (hasFunds) {
      const funds = yield call(fundsServices.fundsInfo, {
        securityType: 'FUND',
      });

      portfolio = portfolio.map((portfolioTitle) => {
        const matchedFund =
          funds.find(
            (fund) =>
              fund.securityType === portfolioTitle.securityType &&
              fund.symbol === portfolioTitle.symbol &&
              fund.securityExchange === portfolioTitle.exchange,
          ) ?? {};

        return { ...portfolioTitle, ...matchedFund };
      });
    }

    const userInstruments = yield select(getAllInstruments);

    const respElementIndex = portfolio.findIndex((el) => el.type === 'resp');

    portfolio.splice(respElementIndex, respElementIndex >= 0 ? 1 : 0);

    portfolio = portfolio.map((portfolioTitle) => {
      const matchedUserInstr = userInstruments.find(
        (userInstr) =>
          userInstr.securityType === portfolioTitle.securityType &&
          userInstr.symbol === portfolioTitle.symbol &&
          userInstr.exchange === portfolioTitle.exchange,
      );

      return {
        ...portfolioTitle,
        country: matchedUserInstr?.country,
        isFavourite: matchedUserInstr?.isFavourite,
        canTrade: matchedUserInstr?.canTrade,
        instrument: matchedUserInstr?.instrument,
        priceRepresentation: matchedUserInstr?.priceRepresentation,
        quantityRepresentation: matchedUserInstr?.quantityRepresentation,
        roundPrice: matchedUserInstr?.roundPrice,
        localStarTtime: matchedUserInstr?.localStarTtime,
        localEndTime: matchedUserInstr?.localEndTime,
        countryDescr: matchedUserInstr?.countryDescr,
      };
    });

    yield put(walletSlice.actions.walletSuccess(portfolio));
  } catch (error) {
    const handled = yield call(handleSagaError, error);
    if (!handled) yield put(walletSlice.actions.walletFailure());
  }
};

const walletSagas = function* () {
  while (true) {
    const authorized = false;
    try {
      while (!authorized) {
        yield take(walletSlice.actions.walletRequest.type);
        yield call(walletWorker);
      }
    } catch {
      yield put(walletSlice.actions.walletFailure());
    }
  }
};

export { walletSagas };
